import { useEffect, useState } from 'react';
import { Manufacturer } from 'types/room';
import {
  getAllOptionStartInspection,
  getAssetModels,
  getAssetTypes,
  getManufactures,
  getSingleEntryFields,
  getSystemDropdownValues,
  getUsers,
  SingleEntryField
} from 'services/option';
import { StorageServices } from 'services/storage';
import { AssetModel } from '../app/pages/ValidationsPage/type';
import { unionBy } from 'lodash';
export type TEditOption = {
  id: number;
  name: string;
  value: string;
};
export interface AssetType {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  assetEntries: AssetEntry[];
}
export type User = {
  name: string;
  role: string;
  email: string;
  address: string;
  lastLoginAt: string;
  isVerified: string;
  id: number;
};
export interface AssetEntry {
  id: number;
  typeId: number;
  fieldId: number;
  createdAt: string;
  updatedAt: string;
  field: Field;
  value?: string;
  index?: number;
  dropdownValueId?: number;
}

export interface Field {
  id: number;
  name: string;
  unit: string;
  category: string;
  createdAt: string;
  updatedAt: string;
  dropdownValueOption?: {
    name: string;
    required: boolean;
    id: number;
  };
}
export type TListOption = {
  room_level_issue_type: TEditOption[];
  asset_issue_type: TEditOption[];
  issue_type: TEditOption[];
  status: TEditOption[];
  inspection_type: TEditOption[];
  inspection_frequency: TEditOption[];
  compliance_issue: TEditOption[];
  asset_types: AssetType[];
  manufactures: Manufacturer[];
  modelsData: AssetModel[];
  users: User[];
};

export type Metadata = DropdownValueOption[];

export type DropdownValueOption = {
  name: string;
  dropdownValues: Item[];
  options: { id: number; type: string }[];
  id: number;
  required: boolean;
  dropdownOptionClients?: { clientId: number; client: { id: number; clientName: string } }[];
  singleDataEntryClients?: { clientId: number; client: { id: number; clientName: string } }[];
};

interface Item {
  id: number;
  name: string;
  value: string;
  createdAt: string;
  updatedAt: string;
}

const initialState: TListOption = {
  room_level_issue_type: [],
  asset_issue_type: [],
  issue_type: [],
  status: [],
  inspection_type: [],
  inspection_frequency: [],
  compliance_issue: [],
  asset_types: [],
  manufactures: [],
  modelsData: [],
  users: []
};
const storage = new StorageServices();

export const useGetOptionStartInspection = () => {
  const token = storage.getAccessToken();
  const [systemDropdownValues, setSystemDropdownValues] = useState<Metadata>();
  const [listOption, setListOption] = useState<TListOption>(initialState);
  const [singleEntryField, setSingleEntryField] = useState<SingleEntryField[]>();

  const handleGetAllOption = async () => {
    const [data, res, resSingleEntry, dataAssets, dataManufactures, resUser, resModel] =
      (await Promise.all([
        getAllOptionStartInspection(),
        getSystemDropdownValues(),
        getSingleEntryFields(),
        getAssetTypes({ page: 1, size: 99999 }),
        getManufactures({ page: 1, size: 99999 }),
        getUsers({ page: 1, size: 99999 }),
        getAssetModels({ page: 1, size: 99999 })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ])) as any;
    setSystemDropdownValues(res.metadata);
    setSingleEntryField(resSingleEntry.singleEntryFields);
    setListOption({
      ...data?.metadata,
      modelsData: unionBy(resModel?.models, 'name'),
      asset_types: dataAssets.types,
      manufactures: dataManufactures?.manufacturers,
      users: [...(resUser.users ?? [])].sort((a, b) =>
        (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
      )
    });
  };

  useEffect(() => {
    if (!token) return;
    handleGetAllOption();
  }, [token]);

  return {
    systemDropdownValues,
    singleEntryField,
    listOption,
    refreshOptions: handleGetAllOption
  };
};
